module.exports = require("@angular/cdk/coercion");


//////////////////
// WEBPACK FOOTER
// external "@angular/cdk/coercion"
// module id = 1001
// module chunks = 0